import $ from "jquery";

import bodyScrollClass from "./bodyScrollClass";
import navigationToggle from "./navigationToggle";
import YoutubeVideo from "./youtubeVideo";
import heroSlider from "./heroSlider";
import logoWallSlider from "./logoWallSlider";
import CardItemGoogleMaps from "./CardItemGoogleMaps";

window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", (event) => {
  bodyScrollClass();
  navigationToggle();
  heroSlider();
  logoWallSlider();

  $(".youtube-video").each((index, item) => {
    new YoutubeVideo($(item));
  });

  $('.card__item__content__map').each((index, item) => {
    new CardItemGoogleMaps($(item));
  });
});
